import { useEffect, useRef } from 'react'
import { createEditorialRevealAnimation } from '@/lib/gsap/editorial-reveals'
import type { ProductCategory } from '@/schemas/product.schema'
import { useProductsByCategory } from '@/services/products/use-products'

export interface CategoryPageModelProps {
  category: ProductCategory
}

export function useCategoryPageModel({ category }: CategoryPageModelProps) {
  const { data: products } = useProductsByCategory(category)
  const gridContainerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (products.length === 0) {
      return
    }

    const animation = createEditorialRevealAnimation(gridContainerRef.current)
    return () => animation?.revert()
  }, [products])

  return {
    category,
    products,
    isEmpty: products.length === 0,
    gridContainerRef,
  }
}
